<template>
  <v-data-table :headers="headers"
                :items="messages"
                :loading="loading"
                :search="search"
                :items-per-page="10"
                :footer-props="{'items-per-page-options': [10, 50, 100, 1000]}">
    <template v-slot:item.id="{item: message}">
      <v-btn :to="{name: 'admin.fax_message.show', params: {messageID: message.id}}"
             small>
        {{ message.id }}
      </v-btn>
    </template>
    <template v-slot:item.status="{item: message}">
      <v-icon v-if="message.is_success"
              color="green"
              :title="message.status">
        fal fa-fw fa-check-circle
      </v-icon>
      <v-icon v-else-if="message.is_failed"
              :title="message.status"
              color="warning">
        fal fa-fw fa-exclamation-triangle
      </v-icon>
      <v-icon v-else-if="message.is_draft"
              :title="message.status">
        fal fa-fw fa-hourglass-start
      </v-icon>
      <v-icon v-else
              :title="message.status"
              color="info">
        fal fa-fw fa-spin fa-spinner
      </v-icon>
    </template>
    <template v-slot:item.pages_count="{item: message}">
      {{ message.pages_complete }} / {{ message.pages_count }}
    </template>
    <template v-slot:item.created_at="{item: message}">
      {{ message.created_at | datetime('MMM D, YYYY h:mm a') }}
    </template>
    <template v-slot:item.updated_at="{item: message}">
      {{ message.updated_at | datetime('MMM D, YYYY h:mm a') }}
    </template>
  </v-data-table>
</template>
<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    messages: {
      type: Array,
      required: true,
    },
    search: {
      type: String,
      required: false,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'ID',
          value: 'id',
        },
        {
          text: 'Sender',
          value: 'user.name',
        },
        {
          text: 'Recipient',
          value: 'contact.name',
        },
        {
          text: 'Company',
          value: 'contact.company_name',
        },
        {
          text: 'Fax Number',
          value: 'fax_number_national',
          cellClass: 'text-nowrap',
        },
        {
          text: 'Fax Pages',
          value: 'pages_count',
        },
        {
          text: 'Fax Status',
          value: 'status',
        },
        {
          text: 'Created',
          value: 'created_at',
        },
        {
          text: 'Updated',
          value: 'updated_at',
        },
      ]
    }
  }
}
</script>
